import { Text } from "@microbeta/ui";
import type React from "react";
import { useTranslation } from "react-i18next";
import { MdRoute, MdTrendingUp } from "react-icons/md";
import { useGradePreference } from "../../hooks";
import { getGradeDisplayByPreference } from "../../utils/difficultyConverter";
import styles from "./RouteStatistics.module.scss";

export interface RouteStatisticsProps {
  routeCount: number;
  minGrade: number | null;
  maxGrade: number | null;
  className?: string;
  showIcon?: boolean;
  compact?: boolean;
}

export const RouteStatistics: React.FC<RouteStatisticsProps> = ({
  routeCount,
  minGrade,
  maxGrade,
  className = "",
  showIcon = true,
  compact = false,
}) => {
  const { t: _t } = useTranslation();
  const gradePreference = useGradePreference();

  const formatGradeRange = () => {
    if (minGrade === null || maxGrade === null) {
      return null;
    }

    if (minGrade === maxGrade) {
      return getGradeDisplayByPreference(minGrade, gradePreference);
    }

    return `${getGradeDisplayByPreference(minGrade, gradePreference)}-${getGradeDisplayByPreference(maxGrade, gradePreference)}`;
  };

  const gradeRange = formatGradeRange();

  if (routeCount === 0) {
    return null;
  }

  return (
    <div
      className={`${styles.container} ${compact ? styles.compact : ""} ${className}`}
    >
      <div className={styles.statItem}>
        {showIcon && <MdRoute className={styles.icon} />}
        <Text variant="small">{routeCount}</Text>
      </div>
      {gradeRange && (
        <div className={styles.statItem}>
          {showIcon && <MdTrendingUp className={styles.icon} />}
          <Text variant="small">{gradeRange}</Text>
        </div>
      )}
    </div>
  );
};
